import type { LumpsumRebalanceCategory, LumpsumRebalanceExecutedRecommendation } from '../../../../api/rebalance.types'
import {
  PlanCategoryBucketKey,
  PLAN_CATEGORY_BUCKET_TITLES,
  PlansPlanMode,
  type PlansActionFilter
} from '../../../../api/types'
import { usePlanCategoryBucket } from '../../../usePlanCategoryBucketExpansion'
import { BucketAccordion } from '../../../lumpsum-ui-components/BucketAccordion'
import { RebalanceExecutedFundCard } from '../cards/RebalanceExecutedFundCard'
import { getCategoryBucketItems } from '../../../../../utils/categoryBucketsUtils'
import { EventNames } from '../../../../../../../../types/misc.types'
import { trackEvent } from '../../../../../../../../utils/appBridge'
import { PlansLumpsumListEventIds, PlansScreen } from '../../../../../analytics/plansEvents'

type RebalanceExecutedBucketAccordionProps = {
  category: LumpsumRebalanceCategory
  categoryId: string
  actionFilter: PlansActionFilter
  isBorderTop?: boolean
}

export function RebalanceExecutedBucketAccordion({
  category,
  categoryId,
  actionFilter,
  isBorderTop = false
}: RebalanceExecutedBucketAccordionProps) {
  const executedRecommendations = getCategoryBucketItems<LumpsumRebalanceExecutedRecommendation>(category?.executedRecommendations)
  const { bucketCompositeKey, isExpanded, toggle } = usePlanCategoryBucket({
    planMode: PlansPlanMode.REBALANCE,
    actionFilter,
    categoryId,
    bucketKey: PlanCategoryBucketKey.executedRecommendations
  })

  return (
    <BucketAccordion
      bucketCompositeKey={bucketCompositeKey}
      title={PLAN_CATEGORY_BUCKET_TITLES[PlanCategoryBucketKey.executedRecommendations]}
      count={executedRecommendations.length}
      isExpanded={isExpanded}
      onToggle={() => {
        trackEvent({
          eventName: EventNames.UserClicked,
          payload: {
            ScreenName: PlansScreen.LumpsumRebalance,
            eventId: PlansLumpsumListEventIds.BucketAccordion,
            buttonLabel: PLAN_CATEGORY_BUCKET_TITLES[PlanCategoryBucketKey.executedRecommendations]
          }
        })
        toggle()
      }}
      isBorderTop={isBorderTop}
    >
      {executedRecommendations.map((recommendation, recommendationIndex) => (
        <RebalanceExecutedFundCard
          key={`${recommendation?.isin ?? 'fund'}-${recommendationIndex}`}
          recommendation={recommendation}
          showBottomDivider={recommendationIndex < executedRecommendations.length - 1}
        />
      ))}
    </BucketAccordion>
  )
}
